import * as React from 'react';



export default class Refresh extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 17" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd" stroke="#FFF" strokeLinecap="round">
            <path d="M10.77 5.385C10.77 2.41 8.357 0 5.384 0 2.41 0 0 2.41 0 5.385c0 2.973 2.41 5.384 5.385 5.384 1.286 0 2.466-.45 3.392-1.203" transform="translate(2 3.137)"/>
            <path strokeLinejoin="round" d="M8.586 3.769L10.769 5.953 12.953 3.769" transform="translate(2 3.137) rotate(-15 10.77 4.86)"/>
        </g>
      </svg>
    )
  }
}
